// extracted by mini-css-extract-plugin
module.exports = {"container":"IconButton_container__Ug9WW","badge":"IconButton_badge__20RzS","disabled":"IconButton_disabled__1e0tc"};